<template>
  <div class="bg-gray-900 text-white min-h-screen">
    <!-- Header Section -->
    <HeaderView />

    <main>
      <!-- Hero Section -->
<!--      <section class="bg-gradient-to-r from-blue-600 to-indigo-500 text-white py-16">-->
      <section class="bg-gradient-to-r from-gray-700 to-indigo-500 text-white py-16">
        <div class="container mx-auto text-center px-4">
          <h2 class="text-5xl font-extrabold mb-6">
            Empower Your Team with Our Tools
          </h2>
          <p class="text-lg font-light leading-relaxed max-w-3xl mx-auto">
            We build 3D-related tools to help you create without limitations. Our cloud-based rendering solutions let you focus on what matters most.
          </p>
        </div>
      </section>

      <!-- Product Cards Section -->
<!--      <section class="py-16 bg-gray-800">-->
      <section class="py-16 bg-gray-700">
        <div class="container mx-auto">
          <h3 class="text-3xl font-bold text-center mb-12">
            Our Products
          </h3>
          <div class="flex justify-center flex-wrap gap-8">
            <div
                v-for="(prod, index) in products"
                :key="index"
                class="bg-gray-700 border border-gray-600 shadow-md hover:shadow-xl transition-all duration-300 rounded-lg max-w-sm overflow-hidden"
            >
              <img :src="prod.logo" alt="Product Image" class="w-full h-48 object-cover" />
              <div class="p-6">
                <div class="flex items-center justify-between mb-4">
                  <h4 class="text-xl font-semibold">{{ prod.name }}</h4>
                  <span
                      class="bg-blue-100 text-blue-800 text-xs font-semibold px-3 py-1 rounded"
                  >
                    {{ prod.type }}
                  </span>
                </div>
                <p class="text-gray-300 text-sm mb-4">{{ prod.desc }}</p>
                <div class="flex items-center justify-between">
                  <span class="text-xl font-bold">{{ prod.price }}</span>
                  <a
                      v-if="prod.link"
                      :href="prod.link"
                      target="_blank"
                      class="bg-blue-600 text-white text-sm font-medium px-4 py-2 rounded-lg hover:bg-blue-700 focus:ring-4 focus:outline-none"
                  >
                    Visit Product
                  </a>
                  <button
                      v-else
                      class="bg-gray-500 text-white text-sm font-medium px-4 py-2 rounded-lg cursor-not-allowed opacity-70"
                      disabled
                  >
                    Coming Soon
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

    <FooterView />
  </div>
</template>

<script>
import render from "@/assets/render.png";
import design from "@/assets/design.jpg";
import HeaderView from "@/components/HeaderView.vue";
import FooterView from "@/components/FooterView.vue";

export default {
  name: "HomePage",
  components: {FooterView, HeaderView },
  data() {
    return {
      products: [
        {
          logo: render,
          name: "Real API",
          desc: "3D Rendering APIs",
          link: "https://realistic3.com",
          price: "Free",
          type: "Rendering APIs",
        },
        {
          logo: design,
          name: "Akad Match",
          desc: "Social Media Application",
          price: "Upcoming",
          type: "Communication",
        },
      ],
    };
  },
};
</script>
